export default __webpack_public_path__ + "static/media/goal7.6d238feb.webp";